import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

export default function TonalLink({ to, kicker, title, description, icon: Icon, tone = 'primary' }) {
  const tones = {
    primary: 'bg-md-primary-container text-md-on-primary-container',
    secondary: 'bg-md-secondary-container text-md-on-secondary-container',
    tertiary: 'bg-md-tertiary-container text-md-on-tertiary-container',
  };
  return (
    <Link to={to} className={cn('group relative min-h-[230px] overflow-hidden rounded-[36px_36px_14px_36px] p-6 transition-all duration-300 ease-md active:scale-[0.98] sm:p-7', tones[tone])}>
      <div className="flex items-start justify-between gap-5">
        <div className="grid h-12 w-12 place-items-center rounded-[18px] bg-md-surface text-md-on-surface shadow-sm"><Icon className="h-5 w-5" /></div>
        <ArrowUpRight className="h-6 w-6 transition-transform duration-300 ease-md group-hover:translate-x-1 group-hover:-translate-y-1" />
      </div>
      <div className="mt-10 text-xs font-medium uppercase tracking-[0.09em]">{kicker}</div>
      <h3 className="mt-2 text-2xl font-medium leading-tight tracking-[-0.025em]">{title}</h3>
      <p className="mt-2 max-w-sm text-sm leading-6">{description}</p>
      <div aria-hidden="true" className="absolute -bottom-7 -right-4 h-20 w-28 rounded-[44px_44px_10px_44px] bg-md-surface" />
    </Link>
  );
}
